function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("7l6f4", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "Trackers", ()=>$22b895744b417ca0$export$a2c5350cd99575c4);
    $parcel$export(module.exports, "default", ()=>$22b895744b417ca0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1Td13;
    var $8h7OC;
    var $2M9zr;
    var $vHAhS;
    const $22b895744b417ca0$export$a2c5350cd99575c4 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("vHAhS")).SpaTransitionResources), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8h7OC")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Td13")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2M9zr")).default), null));
    var $22b895744b417ca0$export$2e2bcd8739ae039 = $22b895744b417ca0$export$a2c5350cd99575c4;
});
parcelRegister("1Td13", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d8c8e5a889639f5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    var $4Pf62;
    var $heNNl;
    var $8zOmE;
    var $2NMNM;
    const $4d8c8e5a889639f5$var$FireDevopsTargetingEvents = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const isDevopsSite = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)().isDevopsProjectCreationScenario;
        (0, $5uXOq.useEffect)(()=>{
            if (isDevopsSite) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'devopsSite visited');
        }, [
            createAnalyticsEvent,
            isDevopsSite
        ]);
        return null;
    };
    const $4d8c8e5a889639f5$var$WithAnalyticsFireDevopsTargetingEvents = (0, (0, parcelRequire("cb25w")).default)()($4d8c8e5a889639f5$var$FireDevopsTargetingEvents);
    const $4d8c8e5a889639f5$var$SafeWithAnalyticsFireDevopsTargetingEvents = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: (0, $84ec84334bef3bce$export$8be180ec26319f9f),
            packageName: (0, $84ec84334bef3bce$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4d8c8e5a889639f5$var$WithAnalyticsFireDevopsTargetingEvents, null));
    var $4d8c8e5a889639f5$export$2e2bcd8739ae039 = $4d8c8e5a889639f5$var$SafeWithAnalyticsFireDevopsTargetingEvents;
});
const $84ec84334bef3bce$export$b8b9d90f9e5bd72b = 'jiraSpaAppsDevopsFireTargetingEvents';
const $84ec84334bef3bce$export$8be180ec26319f9f = 'devopsFireTargetingEvents';
parcelRegister("8h7OC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$713609dc15e1dd6b$export$2e2bcd8739ae039);
    var $7ccGE;
    var $h4kDQ;
    var $4Pf62;
    var $9sGI6;
    var $3sz7O;
    var $hJH2B;
    var $kXU8A;
    var $713609dc15e1dd6b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("9sGI6")).default)((0, (0, parcelRequire("3sz7O")).default), {
        onJswJsdBundleCheck: ()=>(0, (0, parcelRequire("7ccGE")).default)() && (0, (0, parcelRequire("h4kDQ")).default)(),
        onJswConfluenceBundleCheck: ()=>(0, (0, parcelRequire("hJH2B")).default)() && (0, (0, parcelRequire("kXU8A")).default)(),
        onGetFirstActivationDate: ()=>(0, (0, parcelRequire("4Pf62")).getFirstActivationDate)()
    });
});
parcelRegister("7ccGE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19e8ead936151443$export$2e2bcd8739ae039);
    var $4Pf62;
    var $19e8ead936151443$export$2e2bcd8739ae039 = ()=>{
        const products = (0, (0, parcelRequire("4Pf62")).getLicensedProducts)();
        const { JIRA_SOFTWARE: JIRA_SOFTWARE, JIRA_SERVICEDESK: JIRA_SERVICEDESK } = (0, (0, parcelRequire("4Pf62")).LICENSED_PRODUCTS);
        return products[JIRA_SOFTWARE] && products[JIRA_SERVICEDESK];
    };
});
parcelRegister("h4kDQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8ea20320136cb3e$export$2e2bcd8739ae039);
    var $4Pf62;
    var $d8ea20320136cb3e$export$2e2bcd8739ae039 = ()=>{
        const { JIRA_SOFTWARE: JIRA_SOFTWARE, JIRA_SERVICEDESK: JIRA_SERVICEDESK } = (0, (0, parcelRequire("4Pf62")).LICENSED_PRODUCTS);
        const initialProductList = (0, (0, parcelRequire("4Pf62")).getInitialProductList)();
        return initialProductList !== undefined && initialProductList.startsWith(`${JIRA_SOFTWARE}.ondemand,${JIRA_SERVICEDESK}.ondemand`);
    };
});
parcelRegister("3sz7O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$942ae97d144039c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    var $8zOmE;
    const $942ae97d144039c1$var$SEVEN_DAYS_IN_MS = 604800000;
    class $942ae97d144039c1$export$7b4bc8546790dc76 extends (0, $5uXOq.Component) {
        static{
            this.displayName = 'FireEngagementTargetingEvents';
        }
        componentDidMount() {
            const { onJswConfluenceBundleCheck: onJswConfluenceBundleCheck, onJswJsdBundleCheck: onJswJsdBundleCheck, createAnalyticsEvent: createAnalyticsEvent, onGetFirstActivationDate: onGetFirstActivationDate } = this.props;
            const isJswConfluenceBundle = onJswConfluenceBundleCheck();
            const isJswJsdBundle = onJswJsdBundleCheck();
            const firstActivationDate = onGetFirstActivationDate();
            const currentTime = Date.now();
            const timeSinceInstanceActivation = firstActivationDate !== null ? currentTime - firstActivationDate : null;
            if (timeSinceInstanceActivation !== null && timeSinceInstanceActivation > 0 && timeSinceInstanceActivation < $942ae97d144039c1$var$SEVEN_DAYS_IN_MS) {
                if (isJswConfluenceBundle) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'appswitcherSpotlight targeting');
                if (isJswJsdBundle) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'appswitcherjsdspotlight targeting');
            }
        }
        render() {
            return null;
        }
    }
    var $942ae97d144039c1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cb25w")).default)()($942ae97d144039c1$export$7b4bc8546790dc76);
});
parcelRegister("hJH2B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90c06612489fe65b$export$2e2bcd8739ae039);
    var $4Pf62;
    var $90c06612489fe65b$export$2e2bcd8739ae039 = ()=>{
        const products = (0, (0, parcelRequire("4Pf62")).getLicensedProducts)();
        const { JIRA_SOFTWARE: JIRA_SOFTWARE, CONFLUENCE: CONFLUENCE } = (0, (0, parcelRequire("4Pf62")).LICENSED_PRODUCTS);
        return products[JIRA_SOFTWARE] && products[CONFLUENCE];
    };
});
parcelRegister("kXU8A", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$91b3123cd41eab8c$export$2e2bcd8739ae039);
    var $4Pf62;
    var $91b3123cd41eab8c$export$2e2bcd8739ae039 = ()=>{
        const { JIRA_SOFTWARE: JIRA_SOFTWARE, CONFLUENCE: CONFLUENCE } = (0, (0, parcelRequire("4Pf62")).LICENSED_PRODUCTS);
        const initialProductList = (0, (0, parcelRequire("4Pf62")).getInitialProductList)();
        return initialProductList !== undefined && initialProductList.startsWith(`${JIRA_SOFTWARE}.ondemand,${CONFLUENCE}.ondemand`);
    };
});
parcelRegister("2M9zr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5cd084d49def2e59$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    const $5cd084d49def2e59$var$LegacyIssueCreateTrackers = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const trackLegacyIssueCreate = (0, $5uXOq.useCallback)((event)=>{
            if (!(event instanceof CustomEvent)) return;
            const payload = event.detail;
            const trackEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(trackEvent, 'issueCreated inProductSurvey', payload.objectId, {
                ...payload.attributes
            });
        }, [
            createAnalyticsEvent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            document.addEventListener('legacy_legacyIssueCreated', trackLegacyIssueCreate);
            return ()=>document.removeEventListener('legacy_legacyIssueCreated', trackLegacyIssueCreate);
        }, [
            createAnalyticsEvent,
            trackLegacyIssueCreate
        ]);
        return null;
    };
    var $5cd084d49def2e59$export$2e2bcd8739ae039 = $5cd084d49def2e59$var$LegacyIssueCreateTrackers;
});
parcelRegister("vHAhS", function(module, exports) {
    $parcel$export(module.exports, "SpaTransitionResources", ()=>$bcd3bc7bb1c59bcf$export$48fe79d11c18f082);
    var $cb25w;
    var $69lB0;
    const $bcd3bc7bb1c59bcf$export$48fe79d11c18f082 = (0, (0, parcelRequire("cb25w")).default)()((0, (0, parcelRequire("69lB0")).SpaResourceMetricsControllerWithActions));
});
parcelRegister("69lB0", function(module, exports) {
    $parcel$export(module.exports, "SpaResourceMetricsControllerWithActions", ()=>$72b8b17ec8013125$export$89f414cc1bd7e863);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $jcw0u;
    var $4R6GH;
    var $j8DrX;
    var $8zOmE;
    var $kbVA4;
    var $4oDnX;
    var $bVDE5;
    var $2YP9W;
    var $doZTA;
    var $bShz7;
    const $72b8b17ec8013125$var$defaultMetrics = {
        type: null,
        duration: null,
        end: null,
        isCacheHit: null,
        start: 0
    };
    const $72b8b17ec8013125$var$canSendMetrics = ({ duration: duration, end: end, isCacheHit: isCacheHit, start: start })=>isCacheHit !== $72b8b17ec8013125$var$defaultMetrics.isCacheHit && duration !== $72b8b17ec8013125$var$defaultMetrics.duration && start !== $72b8b17ec8013125$var$defaultMetrics.start && end !== $72b8b17ec8013125$var$defaultMetrics.end;
    const $72b8b17ec8013125$var$isCachedResource = (slice, invocationTimestamp)=>!slice.loading && (slice.expiresAt ?? 0) > invocationTimestamp;
    const $72b8b17ec8013125$var$SAMPLING_RATE = 10;
    const $72b8b17ec8013125$var$ResourceMetricTracker = ({ resource: resource, route: currentRoute, createAnalyticsEvent: createAnalyticsEvent, setResourceMetrics: setResourceMetrics, currentMatch: currentMatch, isInitialRender: isInitialRender })=>{
        const [metrics, setMetrics] = (0, $5uXOq.useState)($72b8b17ec8013125$var$defaultMetrics);
        const [isSent, setIsSent] = (0, $5uXOq.useState)(false);
        const slice = (0, (0, parcelRequire("2YP9W")).useResource)(resource);
        (0, $5uXOq.useEffect)(()=>()=>{
                setMetrics({
                    ...$72b8b17ec8013125$var$defaultMetrics
                });
                setIsSent(false);
            }, [
            currentRoute
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (slice.expiresAt === null || isSent) return;
            const invocationTimestamp = Date.now();
            if (metrics.isCacheHit === null && $72b8b17ec8013125$var$isCachedResource(slice, invocationTimestamp)) {
                setMetrics((state)=>({
                        ...state,
                        duration: 0,
                        end: invocationTimestamp,
                        isCacheHit: true,
                        start: invocationTimestamp,
                        type: resource.type
                    }));
                return;
            }
            if (slice.loading && metrics.start === 0) {
                setMetrics((state)=>({
                        ...state,
                        type: resource.type,
                        isCacheHit: false,
                        start: invocationTimestamp
                    }));
                return;
            }
            if (!slice.loading && metrics.start !== $72b8b17ec8013125$var$defaultMetrics.start && metrics.end === $72b8b17ec8013125$var$defaultMetrics.end) setMetrics((state)=>({
                    ...state,
                    duration: invocationTimestamp - state.start,
                    end: invocationTimestamp
                }));
        }, [
            isSent,
            currentRoute,
            metrics,
            resource,
            slice
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const { error: error } = slice;
            if (isSent || !$72b8b17ec8013125$var$canSendMetrics(metrics) || !error && Math.random() * 100 > $72b8b17ec8013125$var$SAMPLING_RATE) return;
            const { isCacheHit: isCacheHit, duration: duration, start: start, end: end, type: resourceType } = metrics;
            const action = error ? 'fetchFailed' : 'fetchSucceeded';
            const analyticsEvent = createAnalyticsEvent({
                action: action
            });
            const errorMessage = error && error instanceof Error ? error.toString() : error;
            const routeName = currentRoute.name ? currentRoute.name : 'empty';
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, `${action} resource`, resource.type, {
                duration: duration,
                isCacheHit: isCacheHit,
                start: start,
                end: end,
                routeName: routeName,
                prefetchStartTime: (0, (0, parcelRequire("bShz7")).getPrefetchStartMark)(currentMatch),
                isInitialRender: isInitialRender,
                resourceType: resourceType,
                ...errorMessage !== null && errorMessage !== undefined ? {
                    error: errorMessage
                } : {}
            });
            if (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: `spaTransitionResources.${(resourceType || '').toLowerCase()}`,
                        packageName: 'jiraSpaTransitionResourcesTracker',
                        teamName: 'magma'
                    },
                    attributes: {
                        isSynthetic: (0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true' || (0, (0, parcelRequire("4R6GH")).fg)('forge_ui_synthetic_check')
                    },
                    error: error,
                    skipSentry: true
                });
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(`resources.${(resourceType || '').toLowerCase()}`, errorMessage || '', error);
            }
            setResourceMetrics({
                end: end,
                isCacheHit: isCacheHit,
                start: start,
                type: resourceType
            });
            setIsSent(true);
        }, [
            createAnalyticsEvent,
            currentRoute,
            isSent,
            metrics,
            setResourceMetrics,
            slice,
            resource,
            currentMatch,
            isInitialRender
        ]);
        return null;
    };
    const $72b8b17ec8013125$export$b5bbbe33c7801196 = ({ createAnalyticsEvent: createAnalyticsEvent, setResourceMetrics: setResourceMetrics })=>{
        const [{ route: currentRoute, match: currentMatch }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const [{ isInitialRender: isInitialRender }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("bShz7")).clearPrefetchStartMarks)(currentMatch);
        }, [
            currentMatch
        ]);
        const resourcesToTrack = (0, $5uXOq.useMemo)(()=>{
            const resources = currentRoute?.resources?.filter((resource)=>resource.type !== (0, (0, parcelRequire("kbVA4")).RESOURCE_TYPE_NOOP)) || [];
            return resources.map((resource)=>(0, ($parcel$interopDefault($5uXOq))).createElement($72b8b17ec8013125$var$ResourceMetricTracker, {
                    key: resource.type,
                    resource: resource,
                    route: currentRoute,
                    currentMatch: currentMatch,
                    createAnalyticsEvent: createAnalyticsEvent,
                    setResourceMetrics: setResourceMetrics,
                    isInitialRender: isInitialRender
                }));
        }, [
            currentRoute,
            currentMatch,
            createAnalyticsEvent,
            setResourceMetrics,
            isInitialRender
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, resourcesToTrack);
    };
    const $72b8b17ec8013125$export$89f414cc1bd7e863 = ({ createAnalyticsEvent: createAnalyticsEvent })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateActionsSubscriber), null, (_, { setResourceMetrics: setResourceMetrics })=>(0, ($parcel$interopDefault($5uXOq))).createElement($72b8b17ec8013125$export$b5bbbe33c7801196, {
                setResourceMetrics: setResourceMetrics,
                createAnalyticsEvent: createAnalyticsEvent
            }));
});
parcelRegister("bShz7", function(module, exports) {
    $parcel$export(module.exports, "setPrefetchStartMark", ()=>$fd73e472799b8227$export$405fde3eab8e39f6);
    $parcel$export(module.exports, "getPrefetchStartMark", ()=>$fd73e472799b8227$export$cbaceb7ffa84279);
    $parcel$export(module.exports, "clearPrefetchStartMarks", ()=>$fd73e472799b8227$export$d6b0928f07bafe57);
    const $fd73e472799b8227$var$prefetchTiming = new Map();
    const $fd73e472799b8227$export$405fde3eab8e39f6 = (match)=>{
        const currentMatch = JSON.stringify(match);
        if (!$fd73e472799b8227$var$prefetchTiming.has(currentMatch)) $fd73e472799b8227$var$prefetchTiming.set(currentMatch, {
            startPrefetchTime: Date.now()
        });
    };
    const $fd73e472799b8227$export$cbaceb7ffa84279 = (match)=>{
        const currentMatch = JSON.stringify(match);
        const { startPrefetchTime: startPrefetchTime } = $fd73e472799b8227$var$prefetchTiming.get(currentMatch) || {
            startPrefetchTime: null
        };
        return startPrefetchTime;
    };
    const $fd73e472799b8227$export$d6b0928f07bafe57 = (match)=>{
        if (!$fd73e472799b8227$var$prefetchTiming || !$fd73e472799b8227$var$prefetchTiming.keys) return;
        const currentMatch = JSON.stringify(match);
        const keys = Array.from($fd73e472799b8227$var$prefetchTiming.keys());
        keys.forEach((mark)=>{
            if (mark !== currentMatch && $fd73e472799b8227$var$prefetchTiming.has(mark)) $fd73e472799b8227$var$prefetchTiming.delete(mark);
        });
    };
});
